






































































































































import { agencyCharge, agencyPay } from '@/api/Agency/agency.api'
import Dialog from '@/components/Dialog.vue'
import UserCard from '@/components/UserCard.vue'
import { VueForm } from '@/utils/interfaces'
import { number } from '@/utils/validators'
import Vue from 'vue'

export default Vue.extend({
  components: {
    appDialog: Dialog,
    appUserCard: UserCard,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  data() {
    return {
      crud: {
        amount: 0,
        service: 'REMITTANCE',
        description: '',
      },
      rules: {
        number: (v: number | string) =>
          number((v || 'e').toString()) ||
          this.$t('validation.must-be-a-number'),
      },
      services: ['REMITTANCE', 'TOP-UP'],
      fields: ['name'],
      loading: false,
    }
  },
  methods: {
    async onTransfer(action: 'send' | 'receive') {
      try {
        const form = this.$refs.form as VueForm
        if (!form.validate()) return
        this.loading = true
        if (action === 'send') {
          await agencyPay({
            ...this.crud,
            agency: this.item.uuid,
          })
          this.item.balance = (
            Number(this.item.balance) + Number(this.crud.amount)
          ).toFixed(2)
        } else {
          await agencyCharge({
            ...this.crud,
            agency: this.item.uuid,
          })
          this.item.balance = (
            Number(this.item.balance) - Number(this.crud.amount)
          ).toFixed(2)
        }
        this.$emit('input', false)
        this.crud = {
          amount: 0,
          service: 'REMITTANCE',
          description: '',
        }
      } finally {
        this.loading = false
      }
    },
  },
})
